import React from 'react';

import { FocusIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <FocusIcon size="xsmall" shouldUseNewLogoDesign label="" />;

export const useFocus = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.FOCUS,
		analyticsName: Products.FOCUS,
		...options,
	});
